export const CITIZEN_PLAY_STORE =
  'https://play.google.com/store/apps/details?id=com.loksy_citizen&hl=en_IN';

export const CITIZEN_LOGIN_PATH = '/user-login';

export const CITIZEN_SPLASH_SCREENS = [
  {
    id: 'intro',
    image: '/images/loki/citizen_loki_intro.png',
    en: {
      title: 'Your Town. Just One Tap Away.',
      body: 'Shops, services, offers, jobs and updates — all in one Citizen app.',
    },
    te: {
      title: 'మీ ఊరు… ఇక ఒక్క ట్యాప్‌లో మీ చేతిలో!',
      body: 'షాపులు, సర్వీసులు, ఆఫర్లు, ఉద్యోగాలు, అప్‌డేట్స్ — అన్నీ Loksy Citizenలోనే.',
    },
    hi: {
      title: 'आपका क़स्बा… अब एक टैप में!',
      body: 'दुकानें, सेवाएँ, ऑफ़र, नौकरियाँ और अपडेट — सब एक Citizen ऐप में.',
    },
  },
  {
    id: 'discover',
    image: '/images/loki/citizen_loki_discover.png',
    en: {
      title: 'Find Shops. Know Services. Grab Local Offers.',
      body: 'Kirana, food, health, services — see what is open around you today.',
    },
    te: {
      title: 'షాపులు కనుగొనండి… సర్వీసులు తెలుసుకోండి… లోకల్ ఆఫర్లు పొందండి!',
      body: 'కిరాణా, ఫుడ్, హెల్త్, సర్వీసులు — ఈరోజు మీ చుట్టూ ఏముందో చూడండి.',
    },
    hi: {
      title: 'दुकानें खोजें. सेवाएँ जानें. लोकल ऑफ़र लें.',
      body: 'किराना, फूड, हेल्थ, सेवाएँ — आज आपके आस-पास क्या खुला है देखें.',
    },
  },
  {
    id: 'radius',
    image: '/images/loki/citizen_loki_radius.png',
    en: {
      title: 'Start Nearby. Stretch the Radius If You Need.',
      body: 'If nothing is near you, expand the radius — from a few km up to All shops.',
    },
    te: {
      title: 'దగ్గర నుంచి మొదలు… దొరకకపోతే రేడియస్ పెంచండి!',
      body: 'సమీపంలో షాపు/సర్వీస్ లేకపోతే రేడియస్ పెంచి మరిన్ని చూడండి. అన్నీ కావాలంటే All కూడా.',
    },
    hi: {
      title: 'पास से शुरू करें. ज़रूरत हो तो रेडियस बढ़ाएँ.',
      body: 'पास में कुछ न मिले तो रेडियस बढ़ाएँ — कुछ किमी से लेकर All shops तक.',
    },
  },
  {
    id: 'contact',
    image: '/images/loki/citizen_loki_contact.png',
    en: {
      title: 'Call. WhatsApp. Navigate — One Tap.',
      body: 'No number hunting. Talk, message, or get directions from the shop page.',
    },
    te: {
      title: 'కాల్ చేయండి… WhatsApp చేయండి… షాపుకి నావిగేట్ చేయండి!',
      body: 'నంబర్ వెతకాల్సిన పని లేదు. షాపు పేజీ నుంచే కాల్, WhatsApp, దారి.',
    },
    hi: {
      title: 'कॉल. WhatsApp. नेविगेट — एक टैप.',
      body: 'नंबर ढूँढने की ज़रूरत नहीं. दुकान पेज से कॉल, WhatsApp या रास्ता.',
    },
  },
  {
    id: 'scan',
    image: '/images/loki/citizen_loki_scan.png',
    en: {
      title: 'Skip the Queue. Scan. Place the Order.',
      body: 'Don’t stand in Q for a token. Scan the shop and place your order from the phone.',
    },
    te: {
      title: 'క్యూలో నిలబడి టోకెన్ కోసం వేచి ఉండకండి… స్కాన్ చేసి ఆర్డర్ పెట్టండి!',
      body: 'టోకెన్ కోసం క్యూలో నిలబడాల్సిన పని లేదు. షాపు స్కాన్ చేసి, ఫోన్‌లోనే ఆర్డర్ పెట్టండి.',
    },
    hi: {
      title: 'कतार छोड़ें. स्कैन करें. ऑर्डर लगाएँ.',
      body: 'टोकन के लिए कतार में न खड़े हों. दुकान स्कैन करें और फ़ोन से ऑर्डर लगा दें.',
    },
  },
  {
    id: 'home',
    image: '/images/loki/citizen_loki_home.png',
    en: {
      title: 'Order From Home. Get It Done Easy.',
      body: 'Pick from the shop catalog, add a note, send the request — from home.',
    },
    te: {
      title: 'ఇంటి నుంచే ఆర్డర్ చేయండి… మీ పని సులభంగా పూర్తి చేసుకోండి!',
      body: 'షాపు క్యాటలాగ్ నుంచి ఎంచుకోండి, నోట్ రాయండి, ఇంటి నుంచే రిక్వెస్ట్ పంపండి.',
    },
    hi: {
      title: 'घर से ऑर्डर करें. काम आसान हो.',
      body: 'दुकान कैटलॉग से चुनें, नोट लिखें, घर बैठे रिक्वेस्ट भेजें.',
    },
  },
  {
    id: 'token',
    image: '/images/loki/citizen_loki_token.png',
    en: {
      title: 'Know Your Turn. Track Your Order.',
      body: 'Follow your turn and order status. While you wait on the board, see that shop and nearby shops’ offers, updates and coupons — waiting time is not wasted.',
    },
    te: {
      title: 'మీ వంతు ఎప్పుడు? మీ ఆర్డర్ ఎక్కడ? తెలుసుకోండి!',
      body: 'మీ వంతు, ఆర్డర్ స్టేటస్ చూడండి. వేచి ఉన్నప్పుడు ఆ షాపు + దగ్గర షాపుల ఆఫర్లు, అప్‌డేట్స్, కూపన్లు — వేచి ఉండే సమయం వృధా కాదు.',
    },
    hi: {
      title: 'अपनी बारी जानें. ऑर्डर ट्रैक करें.',
      body: 'अपनी बारी और ऑर्डर स्टेटस देखें. इंतज़ार में उसी दुकान और आस-पास के ऑफ़र, अपडेट, कूपन — इंतज़ार बेकार नहीं जाता.',
    },
  },
  {
    id: 'coupons',
    image: '/images/loki/citizen_loki_coupons.png',
    en: {
      title: 'Shop More. Save More with Coupons.',
      body: 'Shop offers, daily coupons and rewards — save at places you already go.',
    },
    te: {
      title: 'కొనుగోలు చేయండి… Couponsతో మరింత ఆదా చేసుకోండి!',
      body: 'షాపు ఆఫర్లు, డైలీ కూపన్లు, రివార్డ్స్ — మీరు వెళ్లే షాపుల్లోనే ఆదా.',
    },
    hi: {
      title: 'और खरीदें. कूपन से और बचाएँ.',
      body: 'दुकान ऑफ़र, डेली कूपन, रिवॉर्ड — जहाँ जाते हैं वहीं बचत.',
    },
  },
  {
    id: 'updates',
    image: '/images/loki/citizen_loki_updates.png',
    en: {
      title: 'Stay Updated on What Matters Locally.',
      body: 'Shop boards, town news, holidays, new stock — follow shops and don’t miss it.',
    },
    te: {
      title: 'మీకు ఉపయోగపడే లోకల్ అప్‌డేట్స్ ఎప్పుడూ తెలుసుకోండి!',
      body: 'షాపు బోర్డ్, ఊరి న్యూస్, హాలిడే, కొత్త స్టాక్ — ఫాలో చేసి మిస్ కాకండి.',
    },
    hi: {
      title: 'जो लोकल मायने रखता है, अपडेट रहें.',
      body: 'दुकान बोर्ड, कस्बे की खबर, छुट्टी, नया स्टॉक — फॉलो करें, मिस न करें.',
    },
  },
  {
    id: 'jobs',
    image: '/images/loki/citizen_loki_jobs.png',
    en: {
      title: 'From Local Jobs to Global Opportunities.',
      body: 'Job alerts near you, career profile, resume — local work and wider openings.',
    },
    te: {
      title: 'లోకల్ ఉద్యోగాల నుంచి గ్లోబల్ అవకాశాల వరకు!',
      body: 'మీ దగ్గర జాబ్ అలర్ట్స్, కెరీర్ ప్రొఫైల్, రెజ్యూమ్ — లోకల్ నుంచి మరిన్ని అవకాశాలు.',
    },
    hi: {
      title: 'लोकल नौकरियों से ग्लोबल मौकों तक.',
      body: 'पास की जॉब अलर्ट, करियर प्रोफ़ाइल, रिज्यूमे — लोकल से और मौके.',
    },
  },
  {
    id: 'pamphlet',
    image: '/images/loki/citizen_loki_pamphlet.png',
    en: {
      title: 'Your Local Pamphlets, Now on Your Phone.',
      body: 'Shop posters and pamphlets in your pocket — no paper, still local.',
    },
    te: {
      title: 'మీ లోకల్ పాంప్లెట్లు… ఇక మీ ఫోన్‌లోనే!',
      body: 'షాపు పోస్టర్లు, పాంప్లెట్లు మీ ఫోన్‌లో — కాగితం లేకుండా, లోకల్‌గానే.',
    },
    hi: {
      title: 'आपके लोकल पैम्फलेट, अब फ़ोन में.',
      body: 'दुकान पोस्टर और पैम्फलेट फ़ोन में — कागज़ नहीं, लोकल वही.',
    },
  },
  {
    id: 'watch',
    image: '/images/loki/citizen_loki_watch.png',
    en: {
      title: 'Watch. Discover. Get Rewarded.',
      body: 'Watch local ads, spin, earn coupons and coins — then use them at shops.',
    },
    te: {
      title: 'చూడండి… తెలుసుకోండి… Coupons పొందండి!',
      body: 'లోకల్ యాడ్స్ చూడండి, స్పిన్ చేయండి, కూపన్లు & కాయిన్స్ తీసుకుని షాపులో వాడండి.',
    },
    hi: {
      title: 'देखें. जानें. इनाम पाएँ.',
      body: 'लोकल ऐड देखें, स्पिन करें, कूपन और कॉइन लें — दुकान पर यूज़ करें.',
    },
  },
  {
    id: 'hero',
    image: '/images/loki/citizen_loki_hero.png',
    hero: true,
    en: {
      title: 'Live Local. Do More. Save Time.',
      body: 'Loksy Citizen',
    },
    te: {
      title: 'లోకల్‌గా ఉండండి… ఎక్కువ చేయండి… సమయం ఆదా చేయండి — Loksy Citizen!',
      body: 'Loksy Citizen',
    },
    hi: {
      title: 'लोकल रहें. ज़्यादा करें. समय बचाएँ — Loksy Citizen!',
      body: 'Loksy Citizen',
    },
  },
];

export const CITIZEN_STORY_UI = {
  skip: { en: 'Skip', te: 'దాటవేయి', hi: 'छोड़ें' },
  next: { en: 'Next', te: 'తర్వాత', hi: 'आगे' },
  continue: {
    en: 'Continue to login',
    te: 'లాగిన్‌కి వెళ్లండి',
    hi: 'लॉगिन पर जाएँ',
  },
  pageKicker: {
    en: 'Loksy Citizen',
    te: 'Loksy Citizen',
    hi: 'Loksy Citizen',
  },
  playCta: {
    en: 'Get Loksy on Play Store',
    te: 'Play Storeలో Loksy డౌన్‌లోడ్ చేయండి',
    hi: 'Play Store पर Loksy डाउनलोड करें',
  },
  webCta: {
    en: 'Open Citizen login',
    te: 'Citizen లాగిన్ తెరవండి',
    hi: 'Citizen लॉगिन खोलें',
  },
  autoplay: { en: 'Autoplay', te: 'ఆటోప్లే', hi: 'ऑटोप्ले' },
  pause: { en: 'Pause', te: 'పాజ్', hi: 'पॉज़' },
  prev: { en: 'Previous', te: 'మునుపటి', hi: 'पिछला' },
};
